/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.23",
    versionName: "0.4.0-nightly.2026.6.23",
    versionChannel: "nightly",
    buildDate: "2026-06-23T00:39:04.869Z",
    commitHash: "5ad602453d3372f2a2aebb505ca2ee74fac3f3ee",
};
